import React from 'react'
import { createRoot } from 'react-dom/client'
import { LiveUpdate } from '@capawesome/capacitor-live-update'
import { GoogleAnalyticsService } from '@utils/GoogleAnalyticsService'
import { Capacitor } from '@utils/Capacitor'
import { Capacitor as Cap } from '@capacitor/core'
import { RootContainer } from '@containers/root.container'

async function initApp() {
  await GoogleAnalyticsService.init()
  await Capacitor.init()

  createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <RootContainer />
    </React.StrictMode>,
  )

  const isNative = await Cap.isNativePlatform()
  if (isNative) await LiveUpdate.ready()
}

initApp()
